import React, { useContext, useReducer, useState, useEffect } from 'react';
/// Scroll
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Collapse } from 'react-bootstrap';
/// Link
import { Link } from 'react-router-dom';
import { MenuList } from './Menu';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { ThemeContext } from '../../../context/ThemeContext';
import { useDispatch } from 'react-redux';
import { Logout } from '../../../store/actions/AuthActions';
import { useNavigate } from 'react-router-dom';

import profile from '../../../images/user.jpg';

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: '',
  activeSubmenu: '',
};

const SideBar = () => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout, ChangeIconSidebar } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  const [hideOnScroll, setHideOnScroll] = useState(true);
  const [employee, setEmployee] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function onLogout() {
    dispatch(Logout(navigate));
    // window.location.reload();
    localStorage.removeItem('employee');
    localStorage.removeItem('token');
  }
  useEffect(() => {
    const getEmployeeData = () => {
      const data = localStorage.getItem('user');
      return data ? JSON.parse(data) : null;
    };
    const employee = getEmployeeData();
    setEmployee(employee);
  }, []);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );
  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: '' });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: '' });
    }
  };
  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];
  /// Active menu

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === 'fixed' && sidebarLayout.value === 'horizontal' && headerposition.value === 'static'
          ? hideOnScroll > 120
            ? 'fixed'
            : ''
          : ''
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === 'menu-title') {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li className={` ${state.active === data.title ? 'mm-active' : ''}`} key={index}>
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={'#'}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                      <Collapse in={true}>
                        <ul
                          className={`${menuClass === 'mm-collapse' ? 'mm-show' : ''}`}
                          style={{ visibility: 'visible' }}
                        >
                          {data.content &&
                            data.content.map((data, index) => {
                              return (
                                <li key={index} className={`${state.activeSubmenu === data.title ? 'mm-active' : ''}`}>
                                  {data.content && data.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={data.to}
                                        className={data.hasMenu ? 'has-arrow' : ''}
                                        onClick={() => {
                                          handleSubmenuActive(data.title);
                                        }}
                                      >
                                        {data.title}
                                      </Link>
                                      <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                        <ul className={`${menuClass === 'mm-collapse' ? 'mm-show' : ''}`}>
                                          {data.content &&
                                            data.content.map((data, index) => {
                                              return (
                                                <>
                                                  <li key={index}>
                                                    <Link
                                                      className={`${path === data.to ? 'mm-active' : ''}`}
                                                      to={data.to}
                                                    >
                                                      {data.title}
                                                    </Link>
                                                  </li>
                                                </>
                                              );
                                            })}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link to={data.to}>{data.title}</Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link to={data.to}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
        <div className="dropdown header-profile2 ">
          <div className="header-info2 text-center flex flex-col justify-center items-center py-2 w-full">
            <img src={employee?.image || `https://ui-avatars.com/api/?name=${employee?.name}`} alt="" />{' '}
            <div className="sidebar-info">
              <div>
                <h5 className="font-w500 mb-0">{employee?.name}</h5>
                <span className="fs-12">{employee?.email}</span>
              </div>
            </div>
            <div>
              <button onClick={onLogout} className="btn btn-md text-secondary">
                Logout
              </button>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
